import React from 'react';

interface IncentiveCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
}

const IncentiveCard: React.FC<IncentiveCardProps> = ({ title, description, icon }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
      <div className="text-[#00529B] mb-4">{icon}</div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
      <p className="text-gray-600">{description}</p>
    </div>
  );
};

export default IncentiveCard;
